// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2NU_X","buttons":"Footer_buttons__2GTWl"};